import React, { useMemo, useState, useCallback } from "react";
import { Card, CardBody, Input, Label, Badge } from "reactstrap";

const DnaNumDetails = ({ data = [], selectedDna, onSelectDna }) => {
  const [search, setSearch] = useState("");

  const safeData = useMemo(() => (Array.isArray(data) ? data : []), [data]);

  const options = useMemo(() => {
    const s = (search || "").trim().toLowerCase();

    if (!s) return safeData;

    return safeData.filter((d) => {
      const dna = String(d?.DNANum ?? "").toLowerCase();
      const tool = String(d?.Tool ?? "").toLowerCase();
      const dim = String(d?.DimType ?? "").toLowerCase();
      return dna.includes(s) || tool.includes(s) || dim.includes(s);
    });
  }, [safeData, search]);

  const selectedValue = useMemo(
    () => (selectedDna?.DNANum != null ? String(selectedDna.DNANum) : ""),
    [selectedDna]
  );

  const totalCount = safeData.length;
  const optionCount = options.length;

  const handleSearchChange = useCallback((e) => {
    setSearch(e.target.value);
  }, []);

  const handleSelectChange = useCallback(
    (e) => {
      const v = e.target.value;
      if (!v) {
        onSelectDna?.(null);
        return;
      }

      const found = options.find((x) => String(x?.DNANum) === v);
      onSelectDna?.(found || null);
    },
    [onSelectDna, options]
  );

  return (
    <Card className="shadow-sm" style={{ borderRadius: 12 }}>
      <CardBody>
        <div className="d-flex align-items-center justify-content-between mb-2">
          <Label className="mb-0 fw-semibold">DNA</Label>
          <Badge color="light" className="text-muted">
            {optionCount}/{totalCount}
          </Badge>
        </div>

        <Input
          value={search}
          onChange={handleSearchChange}
          placeholder="Search DNA / Tool / DimType..."
          className="mb-2"
        />

        <Input
          type="select"
          value={selectedValue}
          onChange={handleSelectChange}
          disabled={optionCount === 0}
        >
          <option value="">
            {optionCount ? "Select DNA..." : "No DNA available"}
          </option>
          {options.map((item, idx) => (
            <option key={`${item?.DNANum ?? idx}`} value={String(item?.DNANum)}>
              {String(item?.DNANum)} {item?.Tool ? `— ${String(item.Tool).trim()}` : ""}
            </option>
          ))}
        </Input>

        {selectedDna ? (
          <div className="mt-2 small text-muted">
            Selected: <b>{selectedValue}</b>
            {selectedDna?.DimType ? ` • ${String(selectedDna.DimType).trim()}` : ""}
          </div>
        ) : (
          <div className="mt-2 small text-muted">Pick a DNA to load the grid.</div>
        )}
      </CardBody>
    </Card>
  );
};

export default React.memo(DnaNumDetails);